export let texts = [
  {
      "id": "design_import",
      "name":"Sharing a Design System",
      "title": "Sharing a Design System",
      "css": "",
      "body": `
          Often you want to create a design system, that can be used in multiple prototypes. To share a design system,
          you can simply import the prototyope which contains the design systems into other prototpyes. The components
          of the design system will be available in the widget menu.

          <br>
          To create design system follow these steps:
                  <ol>
                      <li>
                          Create a new prototype and build you design system in here. Define all elements you
                          want to reuse.
                      </li>
                      <li>
                          Create a second prototype.
                      </li>
                      <li>
                         Press <strong>W</strong> or selecting <span class="mdi mdi-puzzle-outline"/> icon. The widget
                         menu will open
                      </li>
                      <li>
                          Click on the <span class="MatcButton">Import</span> button. A list of prototypes will show up.
                      </li>
                      <li>
                          Select the design system prototype and press <span class="MatcButton">Save</span>.
                      </li>
                      <li>
                         A new category will show up on the right side. Select it.
                      </li>
                      <li>
                         You can find here all the widgets you have defined on your design system.
                      </li>
                  </ol>
      `,
      "paragraphs": [

      ]
  }
]